




























































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapState, mapActions } from "vuex";
import CategoriesMenu from "@/components/CategoriesMenu.vue";
import Slider from "@/components/Slider.vue";
import MainMenu from "@/components/MainMenu.vue";
import Autocomplete from "vue2-autocomplete-js";
import http from "@/methods/http.ts";
require("../styles/autocomplete.css");

@Component({
  components: {
    MainMenu,
    CategoriesMenu,
    Slider,
    Autocomplete,
  },
  computed: mapState(["notifications"]),
  methods: mapActions(["readNotification"]),
})
export default class HeaderApp extends Vue {
  dropdown = false;
  dropdownTab = 1;
  notifications_count = 0;
  timer = "";

  siteUrl = "";

  get someStuff() {
    return this.$store.state.someStuff;
  }

  @Watch("someStuff", { immediate: true, deep: true })
  onSomeStuffChange() {
    // do nothing
  }

  changeDropTab(tab) {
    setTimeout(() => {
      this.dropdown = true;
      this.dropdownTab = tab;
    }, 100);
  }

  @Watch("dropdown", { immediate: true, deep: true })
  onDropdownStateChange() {
    const stateKicker = (e) => {
      this.dropdown = false;
      document.removeEventListener("click", stateKicker);
    };

    if (this.dropdown) {
      document.addEventListener("click", stateKicker);
    }
  }

  get sliderState() {
    return this.$store.state.sliderInHeaderShown;
  }

  notificationHandler(id, actionUrl) {
    this["readNotification"](id);
    this.$router.push(actionUrl);
  }

  getInput(data) {
    alert("data");
  }

  getData(data) {
    this.$router.push(data.url);
    //this.$router.push(data.url + '?' + Math.floor((Math.random() * 10000) + 1));
  }

  renderChild(data) {}

  logout() {
    //let name = `${this.$store.state.profile.first_name} ${this.$store.state.profile.last_name}`;
    //let name = `${this.$store.state.profile.full_name}`;
    this.$store.commit("logout");
    //this.$store.commit('notificate', {type: 'action', text: `До скорой встречи, ${name}`});
    this["$cookie"].delete("token");
    this.$router.push("/");
  }

  created() {
    //if(window.location.hostname === 'localhost') {
    //this.siteUrl = 'http://api.checkin.local/api/v1';
    //} else {
    this.siteUrl = "https://api.checkin.kg/api/v1";
    //}
  }
}
